import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { RadioGroup } from 'wix-style-react'
import Header from '../dashboard/DashboardHeader'
import Layout from '../shared/Layout'
import PlanInfo from '../subscriptions/PlanInfo'
import { media, TEAL } from 'components/styles'
import * as _ from 'lodash'
import Text from 'components/common/Text'

const PageContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 18px;`}
`
const PricingTableContainer = styled.div`
  display: flex;
  padding: 30px;
  background-color: #ECECEC;
  justify-content: center;
`
const RadioGroupContainer = styled.div`
  display: inline-block;
  padding: 0 5px;
  _width: 400px;
  line-height: 22px;
  margin-bottom: 30px
`
const CurrentPlan = styled.div`
  display: flex;
  margin-top: 3em;
  margin-bottom: 3em;
  width: 100%;
  height: 5em;
  background-color: ${TEAL};
  justify-content: center;
  align-items: center;
`

class Subscriptions extends Component {

  constructor (props) {
    super(props)

    const intervals = this.getIntervals(props)
    this.state = {
      intervals: intervals,
      currentInterval: intervals[0]
    }
  }

  componentWillReceiveProps (nextProps) {
    const intervals = this.getIntervals(nextProps)
    this.setState({
      intervals: intervals,
      currentInterval: intervals[0]
    })
  }

  planIsAvailable (plan, user) {
    const uplans = _.get(user, 'plans', [])
    const curPlanId = _.get(user, ['subscription', 'plan', 'id'])
    const isHidden = _.get(plan, ['metadata', 'hidden'], false)
    const isAvailable = _.indexOf(uplans, plan.id) >= 0 || plan.id === curPlanId
    return isAvailable && !isHidden
  }

  getIntervals (props) {
    const { user, plans } = props
    const res = []
    for (const pId in plans) {
      const plan = plans[pId]
      const interval = plan.interval
      const isAvailable = this.planIsAvailable(plan, user)
      if (_.indexOf(res, interval) < 0 && isAvailable) res.push(interval)
    }
    console.log('intervals', res)
    return _.sortBy(res, interval => {
      switch (interval) {
        case 'day': return 0
        case 'week': return 1
        case 'month': return 2
        case 'year': return 3
        default: return 4
      }
    })
  }

  descByInterval (interval) {
    switch (interval) {
      case 'day': return 'Daily Billing'
      case 'week': return 'Weekly Billing'
      case 'month': return 'Monthly Billing'
      case 'year': return 'Annual Billing'
      default: return interval
    }
  }

  onIntervalSelected = (v) => {
    this.setState({currentInterval: v})
  }

  renderIntervals () {
    const { intervals, currentInterval } = this.state
    if (intervals.length > 0) {
      return (
        <RadioGroupContainer className='ltr'>
          <RadioGroup
            display='horizontal'
            type='button'
            value={currentInterval}
            onChange={this.onIntervalSelected}
          >
            {_.map(this.state.intervals, interval => {
              return (
                <RadioGroup.Radio
                  key={interval}
                  value={interval}
                  name={interval}
                >
                  {this.descByInterval(interval)}
                </RadioGroup.Radio>
              )
            })}
          </RadioGroup>
        </RadioGroupContainer>
      )
    }
  }

  renderPlans () {
    const { intervals, currentInterval } = this.state
    const { plans, user } = this.props
    const curPlan = _.get(user, ['subscription', 'plan', 'id'])
    let interval = currentInterval
    if (!interval && intervals.length > 0) interval = intervals[0]
    if (interval) {
      const res = _.filter(plans, plan => {
        const isAvailable = this.planIsAvailable(plan, user)
        return (plan.interval === interval) && isAvailable
      })
      return (
        <PricingTableContainer>
          {_.map(res, plan => {
            return (
              <PlanInfo
                key={plan.id}
                plan={plan}
                isCurrentPlan={plan.id === curPlan}
              />
            )
          })}
        </PricingTableContainer>
      )
    }
  }

  renderCurrentPlan () {
    const { user } = this.props
    let price = 0
    let interval = 'month'
    let planName = 'Free'
    if (_.has(user, ['subscription', 'plan'])) {
      const plan = user.subscription.plan
      price = plan.amount / 100
      interval = plan.interval
      planName = plan.name
    }
    return (
      <CurrentPlan>
        <Text color='white'>You are currently subscribed to the <b>{planName}</b> plan, paying a total of <b>{price}</b> per <b>{interval}</b></Text>
      </CurrentPlan>
    )
  }

  renderMain () {
    return (
      <PageContainer>
        {this.renderCurrentPlan()}
        {this.renderIntervals()}
        {this.renderPlans()}
      </PageContainer>
    )
  }

  render () {
    return (
      <Layout
        header={<Header />}
        main={this.renderMain()}
      />
    )
  }
}

Subscriptions.propTypes = {
  plans: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
}

const mapStateToProps = (state) => (
  {
    authData: state.authData,
    plans: state.plans,
    user: state.user
  })

export default connect(mapStateToProps)(Subscriptions)



// WEBPACK FOOTER //
// ./src/components/pages/Subscriptions.js